import { AfterViewInit, Component, inject, viewChild, ViewChild } from "@angular/core";
import { VendorSearchRow } from './types/VendorSearchRow';
import { VendorSearchService } from "./vendor-search.service";
import { VendorSearchParameters } from "./types/VendorSearchParameters";
import { map } from "rxjs";
import { Subscription } from "rxjs";
import { VendorDetailModal } from "../../modals/vendor-detail-modal/vendor-detail-modal.component";
import { filterDefinitions } from "./vendor-search-filters";
import { LoadingService } from "../../shared/services/loading-overlay/loading-overlay.component";
import { SearchType } from "../../shared/services/search-storage.service";
import { Router } from "@angular/router";
import { CurrentUserService } from "../../shared/CurrentUser.service";
import { AppRoles } from "../../shared/enums/AppRoles";
import { GenericSearchPageComponent } from "../generic-search-page/generic-search-page.component";
import { VendorResultsGridComponent } from "../vendor-results-grid/vendor-results-grid.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'vendor-search',
  templateUrl: 'vendor-search.component.html',
  standalone: true,
  imports: [GenericSearchPageComponent, VendorResultsGridComponent, MatIconModule, MatButtonModule],
  providers: [LoadingService, VendorSearchService]
})
export class VendorSearch implements AfterViewInit {
  private searchService = inject(VendorSearchService);
  private router = inject(Router);
  private loadingService = inject(LoadingService);
  private vendorDetailModal = inject(VendorDetailModal);
  private userService = inject(CurrentUserService);
  protected SearchPageComponent = viewChild.required<GenericSearchPageComponent<VendorSearchRow, VendorSearchParameters>>(GenericSearchPageComponent);

  public SearchHistoryType: SearchType = SearchType.Vendor;
  public UserIsAdmin: boolean = false;

  public navigationExtras: Partial<VendorSearchParameters> = this.router.getCurrentNavigation().extras.state;
  public filterCategories = filterDefinitions.filterCategories;
  public searchFn = (params: VendorSearchParameters) => this.searchService.SearchVendors(params);
  public createFn = () => this.create();
  public editFn = (row: VendorSearchRow) => this.vendorDetailModal.ShowModal({ vendorId: row.VendorId }).pipe(map((a) => a !== undefined));

  ngAfterViewInit() {
    this.userService.HasRole(AppRoles.PaymentAdmin).subscribe((hasRole) => {
      this.UserIsAdmin = this.UserIsAdmin || hasRole
    });
    this.userService.GetPaymentAdminCountries().subscribe((countries) => {
      this.UserIsAdmin = this.UserIsAdmin || (countries as number[]).length > 0;
    });

    const loadRef = this.loadingService.StartWaiting("Loading Options...");
    this.searchService.GetDropdowns().subscribe((response) => {
      filterDefinitions.mapFiltersFromApi(response);
      this.SearchPageComponent().InitializeFilters();
      loadRef.Stop();
    });
  }

  private subscriptionsToClose: Subscription[] = [];
  ngOnDestroy() {
    [...this.subscriptionsToClose].forEach((s) => {
      if (s != null && !s.closed) {
        s.unsubscribe();
      }
    });
  }

  protected create = () => this.vendorDetailModal.ShowModal({ vendorId: null }).pipe(map((a) => a !== undefined));

  protected downloadLinkHref() {
    const parameters = this.SearchPageComponent().GetSearchParameters(this.SearchPageComponent().GetCurrentPageSettings());
    window.open(this.searchService.GetExcelDownloadUrl(parameters));
  }
}
